import { render, staticRenderFns } from "./paymentForm.vue?vue&type=template&id=23370d16&"
import script from "./paymentForm.vue?vue&type=script&lang=ts&"
export * from "./paymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./paymentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports